export default {"src":"/_next/static/media/copy-icon-new.abbda078.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};